import React, { useEffect, useState } from "react";
import UseTable from "../../../useHook/useTable/UseTable";
import { useDispatch, useSelector } from "react-redux";

import { columnsTableCounterparty } from "./components/columns";
import {
  getCounterparties,
  deleteCounterparty,
} from "../../../store/slices/counterpartySlice";
import { makeUrl } from "../../../useHook/useTable/components/makeUrl";
// import axios, { API_URL } from "../../../axios";
// import { fetchEventSource } from "@microsoft/fetch-event-source";
const Counterparty = () => {
  const dispatch = useDispatch();
  const selectedCategory = useSelector((state) => state.table.selectedCategory);
  const tableData = useSelector((state) => state.counterparty.counterparties);
  const totalPages = useSelector(
    (state) => state.counterparty.totalCounterparty
  );
  //  state filters
  const [dataInput, setDataInput] = useState({
    code: "",
    name: "",
    phone: "",
  });
  // pagination
  const [PageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    dispatch(
      getCounterparties({
        // type: "custom",
        offset: currentPage === 1 ? 0 : currentPage * PageSize - PageSize,
        search: makeUrl(dataInput),
      })
    );
  }, [selectedCategory, currentPage, dataInput]);

  // input onChannge
  const onChangeData = (name, data) => {
    setDataInput((dataInput) => ({
      ...dataInput,
      [name]: data,
    }));
  };
  const deleteFunc = async (ids) => {
    const req = await dispatch(deleteCounterparty(ids));

    if (req.payload === 200) {
      dispatch(
        getCounterparties({
          // type: selectedCategory,
          offset: currentPage === 1 ? 0 : currentPage * PageSize - PageSize,
          search: makeUrl(dataInput),
        })
      );
    }
    return req;
  };
  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   const headers = {
  //     Authorization: `Bearer ${token}`,
  //   };
  //   const controller = new AbortController();
  //   const connectEventSource = async () => {
  //     await fetchEventSource(`${API_URL}/connect_counterparty`, {
  //       headers,
  //       signal: controller.signal,
  //       async onopen(response) {
  //         if (response.status === 401) {
  //           const response = await axios.get(`${API_URL}/refresh`, {
  //             withCredentials: true,
  //           });
  //           localStorage.setItem("token", response.data.acsses);
  //         }
  //       },
  //       onmessage() {
  //         if (categoryData.find(({ id }) => id === selectedCategory)) {
  //           dispatch(
  //             getCounterparties({
  //               type: selectedCategory,
  //               offset:
  //                 currentPage === 1 ? 0 : currentPage * PageSize - PageSize,
  //             })
  //           );
  //         }
  //       },
  //     });
  //   };
  //   connectEventSource();
  //   return () => {
  //     controller.abort();
  //   };
  // }, [selectedCategory, currentPage]);
  return (
    <UseTable
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      PageSize={PageSize}
      totalPages={totalPages}
      data={tableData}
      columns={columnsTableCounterparty}
      onChangeData={onChangeData}
      dataInput={dataInput}
      movedButton={false}
      deleteFunc={deleteFunc}
      addLink={false}
      detailsLink={"/counterparty/details"}
      // addLink={{ to: "/counterparty/create", label: "Новий контрагент" }}
    />
  );
};

export default Counterparty;
